import { t } from '@lingui/core/macro';
import { create } from 'zustand';
import useMonitorDataOutput from '@lib/hooks/MonitorDataOutput';
import { useApi } from '../../contexts/ApiContext';
import { inventoryUrl } from './InventoryApi';

type StatementOutput={id:number;statement:number;format:string};
const useOutputs=create<{outputs:StatementOutput[]}>(()=>({outputs:[]}));
export function monitorStatementOutput(output:StatementOutput) {
  useOutputs.setState(({outputs})=>({outputs:outputs.some(item=>item.id===output.id)?outputs:[...outputs,output]}));
}
function OutputMonitor({id,statement,format}:StatementOutput) {
  const api=useApi();
  useMonitorDataOutput({api,id,title:t`Inventory statement export`,persistent:true,
    statusUrl:`${inventoryUrl}outputs/${id}/`,outputUrl:`${inventoryUrl}outputs/${id}/download/`,
    onSettled:()=>useOutputs.setState(({outputs})=>({outputs:outputs.filter(item=>item.id!==id)})),
    downloadOnly:true,downloadName:`inventory-statement-${statement}.${format}`,downloadText:t`Download statement`});
  return null;
}
/** Native DataOutput notifications remain mounted while navigating between inventory pages. */
export function InventoryStatementOutputs() {
  const outputs=useOutputs(state=>state.outputs);
  return <>{outputs.map(output=><OutputMonitor key={output.id} {...output}/>)}</>;
}
